/**
 * The wire protocol between the ARCADIA '84: REMASTERED cabinet and a
 * hosted game iframe. Version-tagged so either side can evolve without
 * breaking the other: unknown message types MUST be ignored, never thrown.
 *
 * Same-origin by construction — in dev the shell proxies /games/<id>/ to
 * each game's vite server; in production the game dists are copied into
 * the shell's dist. The cabinet additionally verifies `event.source` is
 * its own iframe, so a stray message from another window is inert.
 */
export const BRIDGE_VERSION = 1;
/** Runtime guard — accepts anything shaped like a bridge message. */
export function isBridgeMessage(data) {
    return (typeof data === 'object' &&
        data !== null &&
        data.arcadia === BRIDGE_VERSION &&
        typeof data.type === 'string');
}
//# sourceMappingURL=protocol.js.map